import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataResult, mapDataResult$ } from '../http/httpDataResponse';
import { BaseNotificationsPreferences } from './base-notifications-preferences';
import { map, mapTo, switchMap } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { ICustomerAppsConfig } from '../config/config.module';
import { AuthenticationService } from '../user/authentication.service';
import { UserCredentialsStore } from '../user/user-credentials-store.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationPreferencesService<NotificationPreferences extends BaseNotificationsPreferences> {
  constructor(
    private configService: ConfigService<ICustomerAppsConfig>,
    private authenticationService: AuthenticationService,
    private userCredentialsStore: UserCredentialsStore,
    private http: HttpClient,
  ) {}

  getNotificationPreferences(): Observable<NotificationPreferences> {
    return this.http
      .get<DataResult<NotificationPreferences>>(`${this.configService.config.apiUrl}/preferences/notifications`)
      .pipe(mapDataResult$());
  }

  setNotificationPreferences(value: NotificationPreferences): Observable<boolean> {
    return this.http.put(`${this.configService.config.apiUrl}/preferences/notifications`, value).pipe(map(() => true));
  }

  updatePushNotificationToken(token: string, firebaseProjectId): Observable<boolean> {
    return this.authenticationService
      .readLoginUserTokens()
      .pipe(
        map((loginTokens) => {
          return loginTokens
            .map((loginToken) => this.userCredentialsStore.getCredentialsForToken(loginToken.token))
            .filter((userCredentials) => userCredentials !== null)
            .map((userCredentials) => userCredentials.userId);
        }),
      )
      .pipe(
        switchMap((userIds) => {
          return this.http.put(`${this.configService.config.apiUrl}/preferences/notifications/update-device-token-for-users`, {
            token,
            userIds,
            firebaseProjectId,
          });
        }),
        map(() => true),
      );
  }

  deletePushNotificationToken(token: string): Observable<boolean> {
    return this.http.delete(`${this.configService.config.apiUrl}/preferences/notifications/device-token/${token}`).pipe(mapTo(true));
  }
}
